const intervals = (init, end, i=1) => {

    let initValue = init;
    let myIntervals = [];

    while (initValue <= end) {
        
        myIntervals.push(initValue);
        initValue += i;
        
    }

    return myIntervals;
}   

const getValueWithSign = value => `${value > 0 ? '+' : ''}${value}`;

const twoDecimal = x => ({value : parseFloat(x.value).toFixed(2), text : parseFloat(x.text).toFixed(2) });
const withGrades = (x) => ({...x, text : `${x.text}º`});
const withSign = (x) => ({ value: getValueWithSign(x.value), text: getValueWithSign(x.value)}); 
const fraccionado = (x) => ({...x, text : `20/${x.text}`});
const toSelect = x => ({value : `${x}`, text : `${x}` });
const cd = x => ({...x, text : `CD ${x.text}` });

const cds = [...intervals(1,6).sort((x,y) => y - x).map(toSelect).map(cd)
    ,{ value : '1/2', text : 'CD 1/2' }
    ,{ value : 'mm', text : 'MM' }
    ,{ value : 'PL', text : 'PL' }
    ,{ value : 'Ciego', text : 'Ciego' }
];

export const esferas = intervals(-30, 30, 0.25).map(toSelect).map(twoDecimal).map(withSign);    
export const cilindros = intervals(-15, 0, 0.25).map(toSelect).map(twoDecimal).map(withSign);
export const ejes = intervals(0, 180, 5).map(toSelect).map(withGrades);
export const adiciones = intervals(0.75, 3.25, 0.25).map(toSelect).map(twoDecimal).map(withSign);
export const avscs = [...[...intervals(15, 25, 5),...intervals(30, 100, 10),...[150,200,400]].map(toSelect).map(fraccionado),...cds];
export const ejesPrima = [45, 90, 180].map(toSelect).map(withGrades);
export const prismasList = intervals(1, 10).map(toSelect);
export const bases = [{value: "Nasal", text : 'Nasal' },{value: "Temporal", text : 'Temporal' },{value: 'Superior', text : 'Superior' },{value: 'Inferior', text : 'Inferior' },]
export const dlps = [...intervals(47,80,1), ...intervals(50, 80, 1).map(x => `${x}/${x-3}`)].map(toSelect);

export const reChanges = [
    {value: "Diario", text : 'Diario' },
    {value: 'Semanal', text : 'Semanal' },
    {value: "Mensual", text : 'Mensual' },
    {value: 'Bimensual', text : 'Bimensual'},
    {value: 'Semestral', text : 'Semestral' },
    {value: 'Anual', text : 'Anual' },
];

export const baseCurve = [...intervals(7, 9, 0.1)].map(toSelect).map(twoDecimal);
export const diameters = [...intervals(13.5, 15, 0.1)].map(toSelect).map(twoDecimal);

export const equivalencia ={

    correcion: [...intervals(4, 20, 0.25)]
    ,positivos: [
        ...[4.25, 4.50, 4.75],
        ...[5, 5.25, 5.50],
        ...[6, 6.25, 6.50, 6.75],
        ...[7, 7.25, 7.75],
        ...[8, 8.25, 8.50, 8.75],
        ...[9.25, 9.50, 9.75],
        ...[10, 10.50, 10.75],
        ...[11, 11.25, 11.75],
        ...[12, 12.25, 12.75],
        ...[13, 13.25, 13.75],
        ...[14, 14.25, 14.75],
        ...[15, 15.50, 15.75],
        ...[16, 16.50, 16.75],
        ...[17.25, 17.50],
        ...[18, 18.25, 18.75],
        ...[19, 19.50, 19.75],
        ...[20.25, 20.50],
        ...[21, 21.25, 21.75],
        ...[22.25, 22.50],
        ...[23, 23.25, 23.75],
        ...[24.25, 24.50],
        ...[25, 25.50],
        ...[26, 26.25],
    ] 
    ,negativos: [
        ...[3.75],
        ...[4, 4.25, 4.50, 4.75],
        ...[5, 5.25, 5.50, 5.50, 5.75],
        ...[6, 6.25, 6.50, 6.50, 6.75],
        ...[7, 7.25, 7.50, 7.75],
        ...[8, 8, 8.25, 8.50, 8.75],
        ...[9, 9.25, 9.25, 9.50, 9.75],
        ...[10, 10, 10.25, 10.50, 10.75, 10.75],
        ...[11, 11.25, 11.50, 11.50, 11.75],
        ...[12, 12.25, 12.25, 12.50, 12.75],
        ...[13, 13, 13.25, 13.50, 13.50, 13.75],
        ...[14, 14, 14.25, 14.50, 14.50, 14.75],
        ...[15, 15.25, 15.25, 15.50, 15.75, 15.75],
        ...[16, 16.25],
    ] 
}

export const getOutWithServices = arr => arr.filter(x => x.typeId != 4 && x.typeId != 1 && x.typeId != 6) // excluir Servicios y Lentes oftalmicos